'use client';

import { useEffect } from 'react';
import { useI18n } from '@/app/providers';
import { locales } from '@/lib/i18n';
import { SITE_URL } from '@/lib/constants';

export function MetaUpdater() {
  const { locale, dictionary } = useI18n();
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : SITE_URL;

  useEffect(() => {
    if (!dictionary?.meta) return;

    // Aggiorna il title
    document.title = dictionary.meta.title;

    // Aggiorna la meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', dictionary.meta.description);

    // Aggiorna Open Graph
    const updateOrCreateMeta = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    updateOrCreateMeta('og:title', dictionary.meta.title);
    updateOrCreateMeta('og:description', dictionary.meta.description);
    updateOrCreateMeta('og:url', baseUrl);
    updateOrCreateMeta('og:locale', locale);

    // Aggiungi hreflang tags
    locales.forEach((loc) => {
      let hreflang = document.querySelector(`link[rel="alternate"][hreflang="${loc}"]`);
      if (!hreflang) {
        hreflang = document.createElement('link');
        hreflang.setAttribute('rel', 'alternate');
        hreflang.setAttribute('hreflang', loc);
        document.head.appendChild(hreflang);
      }
      hreflang.setAttribute('href', loc === 'it' ? baseUrl : `${baseUrl}/${loc}`);
    });

    // Aggiungi x-default hreflang
    let defaultHreflang = document.querySelector('link[rel="alternate"][hreflang="x-default"]');
    if (!defaultHreflang) {
      defaultHreflang = document.createElement('link');
      defaultHreflang.setAttribute('rel', 'alternate');
      defaultHreflang.setAttribute('hreflang', 'x-default');
      document.head.appendChild(defaultHreflang);
    }
    defaultHreflang.setAttribute('href', baseUrl);

    // Aggiorna l'attributo lang dell'html
    document.documentElement.lang = locale;
  }, [locale, dictionary, baseUrl]);

  return null;
}

